import { Button } from '@/components/button';
import { Toggle } from '@/components/toggle';
import { WIDGET_ID } from '@/components/page-editor-widget/page-editor-widget';
import { usePuck } from '@measured/puck';
import { useEffect, useState } from 'react';
import { useLoadPuckData } from '@/features/populate/hooks/use-load-puck-data';
import { PuckEditorProps } from '@/features/populate/components/puck-editor';

interface PuckHeaderProps extends PuckEditorProps {}

export function PuckHeader({ onSave, isLoading }: PuckHeaderProps) {
  const { appState, dispatch } = usePuck();
  const { reset, rootNode, data } = useLoadPuckData(WIDGET_ID);

  const [title, setTitle] = useState<string>('');

  useEffect(() => {
    if (data?.adminTitle) {
      setTitle(data.adminTitle);
    }
  }, [data?.adminTitle]);

  function handleSave() {
    onSave?.(appState.data, rootNode, title);
  }

  function handleNew() {
    reset();
    setTitle('');
  }

  // Local state for toggle
  const [isDraggable, setIsDraggable] = useState(false);

  function handleToggleDraggable(enabled: boolean) {
    setIsDraggable(enabled);
    dispatch({
      type: 'setUi',
      ui: { ...appState.ui, previewMode: enabled ? 'interactive' : 'edit' },
    });
  }

  function handlePreview() {
    window.open(
      `/puck-preview?container=${rootNode?.container}&uuid=${rootNode?.uuid}`,
      '_blank'
    );
  }

  return (
    <div className="pb-4 flex justify-between items-center">
      <div className="flex gap-2 items-center">
        <Button onClick={handleNew}>New</Button>
        <Toggle
          enabled={isDraggable}
          label="Disable drag"
          onChange={handleToggleDraggable}
        />
      </div>
      <div className="flex items-center gap-2">
        <label className="text-sm text-slate-700">Title</label>
        <input
          type="text"
          className="border border-slate-200 rounded px-3 h-9 text-sm"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
        />
        <Button onClick={handlePreview}>Preview</Button>
        <Button onClick={handleSave} disabled={isLoading} loading={isLoading}>
          Save
        </Button>
      </div>
    </div>
  );
}
